import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../../shared/button.component';

import { verifyParamOptionsQuery, showTestCustomReportQueryParamModal } from '../store/actions';
import { isVerifyingParamToEditQuerySelector } from '../store/selectors';
import { useVerifyQueryLogic } from './useVerifyQueryLogic';

const TestQueryButton = ({
  isVerifyingParamToEditQuery,
  verifyParamOptionsQuery,
  showTestCustomReportQueryParamModal,
  hidden,
  formik,
}) => {
  const { verifyQuery, isQueryType, optionsQueryParams } = useVerifyQueryLogic({
    formik, verifyParamOptionsQuery,
  });

  const submitAction = useCallback(() => {
    if (isQueryType && optionsQueryParams.length) {
      showTestCustomReportQueryParamModal({ isOpenForSubmit: false });
      return;
    }
    if (isQueryType && !optionsQueryParams.length) {
      verifyQuery();
      return;
    }
  }, [verifyQuery, optionsQueryParams, isQueryType, showTestCustomReportQueryParamModal]);

  return !hidden
    ? (
      <div className="query-submit-btn">
        <Button isLoading={isVerifyingParamToEditQuery} onClick={submitAction}>
          Verify
        </Button>
      </div>
    )
    : null;
};

TestQueryButton.propTypes = {
  isVerifyingParamToEditQuery: PropTypes.bool.isRequired,
  verifyParamOptionsQuery: PropTypes.func.isRequired,
  showTestCustomReportQueryParamModal: PropTypes.func.isRequired,
  formik: PropTypes.shape({}).isRequired,
  value: PropTypes.string,
  hidden: PropTypes.bool,
};


export default connect(
  state => ({
    isVerifyingParamToEditQuery: isVerifyingParamToEditQuerySelector(state),
  }),
  {
    verifyParamOptionsQuery,
    showTestCustomReportQueryParamModal,
  }
)(TestQueryButton);
